/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Delete_ConfirmInputs */

const en_us2_gyms_delete_confirm = /** @type {(inputs: Gyms_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const pt_br2_gyms_delete_confirm = /** @type {(inputs: Gyms_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir`)
};

const es_419_gyms_delete_confirm = /** @type {(inputs: Gyms_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const pt_pt2_gyms_delete_confirm = /** @type {(inputs: Gyms_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const fr_fr2_gyms_delete_confirm = /** @type {(inputs: Gyms_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const de_de2_gyms_delete_confirm = /** @type {(inputs: Gyms_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

const it_it2_gyms_delete_confirm = /** @type {(inputs: Gyms_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Gyms_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_delete_confirm = /** @type {((inputs?: Gyms_Delete_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Delete_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_delete_confirm(inputs)
	if (locale === "es-419") return es_419_gyms_delete_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_delete_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_delete_confirm(inputs)
	if (locale === "de-DE") return de_de2_gyms_delete_confirm(inputs)
	if (locale === "it-IT") return it_it2_gyms_delete_confirm(inputs)
	return en_us2_gyms_delete_confirm(inputs)
});
export { gyms_delete_confirm as "gyms.delete_confirm" }